import {ApplicationLink, ApplicationTopic} from '../../../applications/bridge/v2/types/bridgeTypesV2';
import {serializeTopicForApplication} from '../../../helpers/models/applicationSerializationHelpers';
import {findLegacyTopicTypeForApplication} from '../../../helpers/models/legacyApplicationHelpers';
import {tryParsePublicId} from '../../../models/applications/publicIdTypes';
import {createTopicAsync} from '../../../services/topics';
import {ThunkAsyncAction} from '../../appThunk';
import {getCompany} from '../company/companySelectors';
import {
  addTopicToConversationsAction,
  removeTopicFromConversationsAction,
} from '../conversations/topicConversationsActions';
import {getLegacyApplications} from './legacyApplicationsSelectors';

interface ApplicationTopicTemplate {
  /** Human readable name. */
  name?: string;
  /** URL of the topic. */
  externalUrl: string;
}

export function addLegacyApplicationTopicToConversationsAsyncAction(
  applicationId: number,
  conversationIds: ReadonlyArray<number>,
  topicTemplate: ApplicationTopicTemplate,
): ThunkAsyncAction<ApplicationTopic | ApplicationLink> {
  return async (dispatch, getState) => {
    const {externalUrl, name} = topicTemplate;
    const application = getLegacyApplications(getState())[applicationId];
    if (!application) {
      throw new Error('Application not found.');
    }

    const type = findLegacyTopicTypeForApplication(application);

    // Create the topic.
    const company = getCompany(getState());
    const topic = await createTopicAsync(company, name || '', externalUrl, type);

    // Apply it to the conversations/
    await dispatch(addTopicToConversationsAction(conversationIds, topic.id));

    return serializeTopicForApplication(topic);
  };
}

export function removeLegacyApplicationLinkFromConversationAsyncAction(
  applicationId: number,
  linkId: string,
  conversationIds: ReadonlyArray<number>,
): ThunkAsyncAction {
  return async (dispatch, getState) => {
    const application = getLegacyApplications(getState())[applicationId];
    if (!application) {
      throw new Error('Application not found.');
    }

    const topicId = tryParsePublicId(linkId);
    if (!topicId) {
      throw new Error('Link not found');
    }

    await dispatch(removeTopicFromConversationsAction(conversationIds, topicId));
  };
}
